import 'css-chunksrc/client/scenes/zone/styles.scss';export default {
  "zone": "_zone_w8wlr_1",
  "loader": "_loader_w8wlr_6",
  "loaderMain": "_loaderMain_w8wlr_14",
  "main": "_main_w8wlr_21",
  "avatar": "_avatar_w8wlr_27",
  "header": "_header_w8wlr_32",
  "heading": "_heading_w8wlr_39",
  "zoneName": "_zoneName_w8wlr_47",
  "name": "_name_w8wlr_56",
  "title": "_title_w8wlr_60",
  "link": "_link_w8wlr_65",
  "description": "_description_w8wlr_72",
  "tabs": "_tabs_w8wlr_78",
  "tab": "_tab_w8wlr_78",
  "selectedTab": "_selectedTab_w8wlr_97",
  "body": "_body_w8wlr_101"
};